module.exports = __webpack_public_path__ + "assets/b18.png";


//////////////////
// WEBPACK FOOTER
// ./images/boomerang-frames/b18.png
// module id = 603
// module chunks = 0